<template>
  <div class="text-gray-500 text-center mx-auto w-3/4 max-w-[350px]">
    <div class="flex justify-center my-4">
      <PermissionStatusCircle icon="icon-image" ready></PermissionStatusCircle>
    </div>
    <div class="font-bold text-lg text-gray-700">Photo Gallery</div>
    <p class="my-6">
      <span class="text-gray-700 font-medium">NCSS</span> needs access to your photos in order to upload
      <span class="text-gray-700 font-medium">equipment images</span> and
      <span class="text-gray-700 font-medium">property documents</span>.
    </p>
    <div v-if="photoPermission.ready">
      <div class="text-lg font-bold text-gray-700">Good to go!</div>
      <p>NCSS has the necessary access to Photos<br /><span class="text-gray-700 font-bold">Thank you</span></p>
    </div>
    <PermissionDialog v-else>"NCSS" Would Like to Access Your Photo Library</PermissionDialog>
  </div>
</template>

<script setup lang="ts">
import PermissionStatusCircle from '@/components/permissions/PermissionStatusCircle.vue';
import PermissionDialog from './PermissionDialog.vue';
import { usePhotoGalleryPermission } from '@/stores/permissions/gallery-permission.store';

const photoPermission = usePhotoGalleryPermission();
</script>

<style scoped></style>
